export default __webpack_public_path__ + "static/media/furgon-grande.d85897c8.webp";